import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2adf7924"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/logo.png",
  alt: "КлеверFarmer",
  height: "38"
}, null, -1))
const _hoisted_2 = { style: {"color":"#ebf1e5"} }
const _hoisted_3 = {
  key: 0,
  style: {"color":"orangered","text-shadow":"1px 1px 1px #000"}
}
const _hoisted_4 = { class: "bg-primary q-px-md q-pb-md q-pt-md" }
const _hoisted_5 = { class: "bg-primary q-px-md q-pb-md q-pt-md" }
const _hoisted_6 = { class: "wrapper-org" }

import { useAbility } from '@casl/vue';
import {
  computed, toRefs,
} from 'vue';
import { useRoute } from 'vue-router';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import UserProfileDialog from '@/dialogs/UserProfileDialog/UserProfileDialog.vue';
import Search from '@/components/Search/Search.vue';
import routeNames from '@/router/routeNames';
import { useUserStore } from '@/stores';
import OrganizationAutocomplete from '@/components/OrganizationAutocomplete/OrganizationAutocomplete.vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileLeftDrawerNavigation',
  props: {
    leftDrawerOpen: { type: Boolean }
  },
  emits: ['update:left-drawer-open'],
  setup(__props: any) {




const isStaging = !!process.env.VUE_APP_STAGING;
const q = useQuasar();
const { t } = useI18n();
const userStore = useUserStore();
const { user } = toRefs(userStore);

const listItemNavigation = computed(() => {
  const { can } = useAbility();
  const $route = useRoute();

  const list = [];
  if (can('read', 'Districts')) {
    list.push({
      to: { name: routeNames.districts },
      icon: 'mdi-earth',
      title: t('areas.title'),
    });
  }
  if (can('read', 'Organizations')) {
    list.push({
      to: !can('read', 'Districts') ? '/' : {
        name: routeNames.organizations,
        query: $route.query.districtId ? { districtId: $route.query.districtId } : {},
      },
      icon: 'mdi-home-variant',
      title: t('organizations.title'),
    });
  }

  if (can('show', 'fieldMeteoIcons') || $route.query.organizationId) {
    list.push({
      to: { name: routeNames.fields, query: { ...$route.query } },
      icon: 'mdi-sprout',
      title: t('fields.title'),
    });
  }

  if (can('show', 'fieldMeteoIcons')) {
    list.push({
      to: { name: routeNames.meteos },
      icon: 'mdi-weather-cloudy',
      title: t('meteoStations.title'),
    });
  }

  if (can('show', 'StationOperability')) {
    list.push({
      to: { name: routeNames.meteoHealth },
      icon: 'mdi-chart-bar-stacked',
      title: t('meteoStations.stationCapacityAssessment'),
    });
  }

  if (can('show', 'fieldMeteoIcons')) {
    list.push({
      to: { name: routeNames.agrochemicalAnalysis },
      icon: 'mdi-flask-plus-outline',
      title: t('agroChemicalExamination.title'),
    });
  }

  return list;
});

const openUserProfileDialog = () => {
  q.dialog({
    component: UserProfileDialog,
    componentProps: { user: user.value },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_drawer, {
    "model-value": _ctx.leftDrawerOpen,
    overlay: "",
    bordered: "",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:left-drawer-open', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, {
        inset: "",
        class: "bg-primary text-white no-border-radius no-padding flex flex-center"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("span", _hoisted_2, [
            _createTextVNode("3.0 "),
            isStaging
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "staging"))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(OrganizationAutocomplete)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Search)
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_q_item, {
        clickable: "",
        onClick: openUserProfileDialog
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { avatar: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_avatar, {
                "text-color": "primary",
                icon: "mdi-account-circle-outline"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('personalAccount.title')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })), [
        [_directive_ripple]
      ]),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_list, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItemNavigation.value, ({icon, to, title}) => {
            return (_openBlock(), _createElementBlock("div", { key: title }, [
              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                to: to,
                clickable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_avatar, {
                        "text-color": "primary",
                        icon: icon
                      }, null, 8, ["icon"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(title), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["to"])), [
                [_directive_ripple]
              ]),
              _createVNode(_component_q_separator, { inset: "" })
            ]))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_q_separator),
        _createVNode(_component_q_item, {
          to: { name: _unref(routeNames).organizationProfile }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_avatar, {
                  "text-color": "primary",
                  icon: "mdi-briefcase-variant"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('settings')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})